export default __webpack_public_path__ + "d4195c4927fa13a50d3953475d0a0e10.png";